import { render, staticRenderFns } from "./EmployeeRemainingLeaveCount.vue?vue&type=template&id=79f3c6a7&scoped=true&"
import script from "./EmployeeRemainingLeaveCount.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeRemainingLeaveCount.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f3c6a7",
  null
  
)

export default component.exports